<div class="fc-organization-exists-container">
    <div class="fc-organization-exists">
        <div class="fc-organization-exists-image">
            <img src="assets/img/fc_organization_exists.svg" />
        </div>
        <div class="fc-organization-exists-header">
            {{ 'SIGNUP.FORM.ORGANIZATION_JOIN.HEADER' | translate }}
        </div>

        <div class="fc-organization-exists-address">
            <div>{{ organization?.name }},</div>
            <div>{{ organization?.address?.line1 }},</div>
            <div>{{ organization?.address?.zip }}, {{ organization?.address?.city }}</div>
        </div>
    </div>
    <div class="fc-team-invite">
        <div class="fc-team-invite-action">
            <button fcp-outlined-button (click)="backClicked.emit()" [size]="'large'">
                {{ 'SIGNUP.BUTTONS.GO_BACK' | translate }}
            </button>
            <button fcp-filled-button [size]="'large'" data-e2e-hook="send-request" (click)="sendTeamInviteRequest()">
                {{ 'SIGNUP_BUTTONS_FINISH_REQUEST' | translate }}
            </button>
        </div>
    </div>
</div>
